import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes'; // Tus rutas definidas anteriormente

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

// Guardia de ruta para verificar la autenticación
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const isAuthenticated = localStorage.getItem('userToken'); // O tu lógica de verificación
    if (!isAuthenticated) {
      next({ name: 'login' }); // Redirige a la página de inicio de sesión si no está autenticado
    } else {
      next(); // Continúa a la ruta si está autenticado
    }
  } else {
    next(); // Si la ruta no requiere autenticación, simplemente continúa
  }
});

export default router;
